// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/select2-bootstrap-theme/dist/select2-bootstrap.css
// module id = 875
// module chunks = 1